import { render, staticRenderFns } from "./GameSearchFilters.vue?vue&type=template&id=5add2f0f&scoped=true&"
import script from "./GameSearchFilters.vue?vue&type=script&lang=js&"
export * from "./GameSearchFilters.vue?vue&type=script&lang=js&"
import style0 from "./GameSearchFilters.vue?vue&type=style&index=0&id=5add2f0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5add2f0f",
  null
  
)

export default component.exports